export const ABOUT_US = "https://www.chargepoint.com/";
export const CONTACT_US = "https://www.chargepoint.com/support";
export const PRIVACY =
  "https://na.chargepoint.com/privacy_policy?instance=NA-US&locale=en-US";
export const PRIVACY_CL =
  "https://cpnos.ev-chargepoint.com/privacy_policy_mobile?instance=NA-US&country_id=233&locale=en";
